import type { ContractListItem } from "../types/UserRole";

export function formatContractSelectLabel(contract: ContractListItem): string {
  const name =
    contract.name?.trim() ||
    contract.shortName?.trim() ||
    `Contract ${contract.id}`;

  const statusName = contract.contractStatusName?.trim();
  const statusIsDefault = contract.contractStatusDefaultValue === 1;

  if (!statusName || statusIsDefault) {
    return name;
  }

  return `${statusName} -> ${name}`;
}

export function toContractSelectOptions(contracts: ContractListItem[]) {
  return contracts.map((contract) => ({
    value: String(contract.id),
    label: formatContractSelectLabel(contract),
  }));
}
